import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const ADVANTAGE = 'Advantage';
const PREMIER = 'Premier';

const experimentPackageCopy = {
  ADVANTAGE_MONTHLY: {
    id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageMonthly',
    defaultMessage: ADVANTAGE,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageMonthly',
      message: '[Type: Heading][Vis.: high] - Advantage Monthly package name heading',
      project: PROJECT_NAME,
    },
  },
  ADVANTAGE_ANNUAL: {
    id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageAnnual',
    defaultMessage: ADVANTAGE,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesAdvantageAnnual',
      message: '[Type: Heading][Vis.: high] - Advantage Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  BASIC_FREE: {
    id: 'Pricing.experimentPackageCopy.SharedPagesBasicFree',
    defaultMessage: 'Free',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesBasicFree',
      message: '[Type: Heading][Vis.: high] - Basic package name heading',
      project: PROJECT_NAME,
    },
  },
  BASIC_ALWAYS_FREE_BYLINE: {
    id: 'Pricing.experimentPackageCopy.BasicAlwaysFreeByline',
    defaultMessage: 'Create as many surveys and forms as you need. Always free.',
    desc: {
      id: 'Pricing.experimentPackageCopy.BasicAlwaysFreeByline',
      message: '[Type: Heading][Vis.: high] - Basic package byline',
      project: PROJECT_NAME,
    },
  },
  BEST_VALUE: {
    id: 'Pricing.experimentPackageCopy.Grow2792BestValue',
    defaultMessage: 'Best value',
    desc: {
      id: 'Pricing.experimentPackageCopy.Grow2792BestValue',
      message: '[Type: Heading][Vis.: high] - Best value ribbon',
      project: PROJECT_NAME,
    },
  },
  CONTACT_SALES: {
    id: 'Pricing.experimentPackageCopy.SharedPagesContactSales',
    defaultMessage: 'Contact Sales',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesContactSales',
      message: '[Type: Heading][Vis.: high] - Package CTA contact sales button',
      project: PROJECT_NAME,
    },
  },
  ENTERPRISE_CONTACT_SALES: {
    id: 'Pricing.experimentPackageCopy.EnterpriseContactSales',
    defaultMessage: 'Contact sales for pricing',
    desc: {
      id: 'Pricing.experimentPackageCopy.EnterpriseContactSales',
      message: '[Type: Heading][Vis.: high] - Package header contact sales for pricing byline',
      project: PROJECT_NAME,
    },
  },
  PREMIER_ANNUAL: {
    id: 'Pricing.experimentPackageCopy.SharedPagesPremierAnnual',
    defaultMessage: PREMIER,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesPremierAnnual',
      message: '[Type: Heading][Vis.: high] - Premier Annual package name heading',
      project: PROJECT_NAME,
    },
  },
  RECOMMENDED: {
    id: 'Pricing.experimentPackageCopy.Grow2792Recommended',
    defaultMessage: 'Recommended for you',
    desc: {
      id: 'Pricing.experimentPackageCopy.Grow2792Recommended',
      message: '[Type: Heading][Vis.: high] - Recommended for you ribbon',
      project: PROJECT_NAME,
    },
  },
  SELECT: {
    id: 'Pricing.experimentPackageCopy.SharedPagesSelect',
    defaultMessage: 'Select',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesSelect',
      message: '[Type: Heading][Vis.: high] - Package CTA select button',
      project: PROJECT_NAME,
    },
  },
  SIGN_UP: {
    id: 'Pricing.experimentPackageCopy.SharedPagesSignup',
    defaultMessage: 'Sign up',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesSignup',
      message: '[Type: Heading][Vis.: high] - Package CTA sign up button',
      project: PROJECT_NAME,
    },
  },
  TEAM_ADVANTAGE: {
    id: 'Pricing.experimentPackageCopy.SharedPagesTeamAdvantage',
    defaultMessage: ADVANTAGE,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesTeamAdvantage',
      message: '[Type: Heading][Vis.: high] - Team Advantage package name heading',
      project: PROJECT_NAME,
    },
  },
  TEAM_PREMIER: {
    id: 'Pricing.experimentPackageCopy.SharedPagesTeamPremier',
    defaultMessage: PREMIER,
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesTeamPremier',
      message: '[Type: Heading][Vis.: high] - Team Premier package name heading',
      project: PROJECT_NAME,
    },
  },
  YOUR_PLAN: {
    id: 'Pricing.experimentPackageCopy.SharedPagesYourPlan',
    defaultMessage: 'Your plan',
    desc: {
      id: 'Pricing.experimentPackageCopy.SharedPagesYourPlan',
      message: '[Type: Heading][Vis.: high] - Package CTA your plan copy for logged in users',
      project: PROJECT_NAME,
    },
  },
  SAVE_WITH_ANNUAL: {
    id: 'Pricing.experimentPackageCopy.SaveWithAnnual',
    defaultMessage: 'Save {percentage}% with an <span id="group">annual plan</span>',
    desc: {
      id: 'Pricing.experimentPackageCopy.SaveWithAnnual',
      message: '[Type: Link][Vis.: high] - Package link to save with annual plan',
      project: PROJECT_NAME,
    },
  },
  SAVE_MORE_WITH_TEAMS: {
    id: 'Pricing.experimentPackageCopy.SaveWithTeams',
    defaultMessage: 'Save {percentage}% with <span id="group">3+ users</span>',
    desc: {
      id: 'Pricing.experimentPackageCopy.SaveWithTeams',
      message: '[Type: Link][Vis.: high] - Package link to save with more with a teams plan',
      project: PROJECT_NAME,
    },
  },
};

export default experimentPackageCopy;
